import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { DATASOURCE } from 'Constants'
import { getApiData } from 'helpers/api'
import Waiting from 'screens/Waiting'
import SiteDown from 'auth/SiteDown'
import AuthWrapper from 'auth/AuthWrapper'
import { Event } from 'components/Event'

class Initializer extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      isLoaded: false,
      isFailed: false
    };
  }

  componentDidMount() {
    const { t } = this.props;
    setTimeout(() => {
      if (!this.state.isLoaded) {
        this.setState({isFailed: true});
        let s = "";
        console.log("Awaiting Initializer:");
        let str = "DataReceived [" + this.props.dataReceived + "]";
        if (! this.props.dataRecived) {
          console.warn("Data not received. Check API Gateway and Query Service.");
        }
        s = s + str;
        if (this.props.tenant === "") {
          console.warn("Tenant info not received. Check Orion and AzureOauthToken App.");
        }
        str = " Tenant [" + this.props.tenant + "]";
        s = s + str;
        if (t("Initializer.Welcome") === "Initializer.Welcome") {
          str = " Locale json not initialized. Likely dev issue.";
          console.warn(str);
        } else {
          str = " Message [" + t("Initializer.Welcome") + "]";
        }
        s = s + str;
        Event("initializer failed on timeout", true, s);
      }
    },20000);
  }

  didUpdate = false;

  componentDidUpdate(prevProps) {
    const { t } = this.props;
    if (!this.state.isLoaded && this.props.dataReceived && 
        this.props.tenant !== "" && t("Initializer.Welcome") !== "Initializer.Welcome") {
      this.setState({isLoaded: true, isFailed: false});
    }
    if (this.props.tenant !== "" && prevProps.tenant === "" && !this.didUpdate) {
      this.didUpdate = true; // wait for data but only do this update once
      getApiData(DATASOURCE.AGENT_NORMALIZER);
      getApiData(DATASOURCE.TENANT_INFO, this.props.location.search);
    }
  }

  render() {
    // if you're in here looking for why the loading page "blinks", it's redirecting to
    // orion's oauth in that time. Design choice (so far) to have the loading page before
    // the redirect rather than a blank page
    if (this.state.isFailed) {
      return (
        <AuthWrapper {...this.props}>
          <SiteDown {...this.props}/>
        </AuthWrapper>
      );
    } else if (!this.state.isLoaded) {
      return (
        <AuthWrapper {...this.props}>
          <Waiting {...this.props}/>
        </AuthWrapper>
      );
    }
    return (
      <AuthWrapper {...this.props}>
        {this.props.children}
      </AuthWrapper>
    );
  };
}

const mapToProps = state => {
  return {
    agentPatterns: state.agentIds.patterns,
    dataReceived: state.agentIds.received,
    tenant: state.userSession.tenantId
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(Initializer)
);
